import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { resetState } from '../store';

function ResetStateOnLeave() {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetState());
        };
    }, [ dispatch ]);

    return <Outlet />;
}

export default memo(ResetStateOnLeave);
